import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { ICommitmentEditorItem } from '../../../components/widgets/public/partner360/commitment/models'

import { ICallJBPCommitmentDataInitParameters } from './models/callJBPCommitmentDataInitParameters'

export const callJBPCommitmentDataInit = async ({
  ownerId,
  partnerId,
  programType,
  fYear,
}: ICallJBPCommitmentDataInitParameters): Promise<ICommitmentEditorItem[]> => {
  if (!partnerId || !programType || !fYear) {
    return []
  }

  const url = proxy('/webservice/621/sp/v3/spJBPCommitmentDataInit/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': programType,
  }
  const response = await Rest.post({ url, payload, headers })
  if (response && response['Rows']) {
    return response['Rows']
  }
  return []
}
